import * as mod from '../../models/lesionados';

import { Injectable } from "@angular/core";
import { BaseService } from "../baseService";
import { HttpClient } from "@angular/common/http";
import { Http } from "@angular/http";
import { BehaviorSubject, Observable } from "rxjs";
import { Proxy } from '../proxy/proxy.service';

@Injectable()
export class LesionadosService extends BaseService {
  private readonly _NombreServicio: string = 'cFutbolActas/';

  // #region Propiedades del servicio
  private lesionados: mod.IActasLesiones_DTO;
  l$: BehaviorSubject<mod.IActasLesiones_DTO> = new BehaviorSubject<mod.IActasLesiones_DTO>(null);
  lesionados$: Observable<mod.IActasLesiones_DTO> = this.l$.asObservable();
  // #endregion

  constructor(http: HttpClient, http2: Http) {
    super(http, http2);
  }

  // #region Métodos relacionados con el controlador API al que se hacen las llamadas.

  /**
   * Guarda la información de los lesionados
   * @param urlBase   Url de la API a la que se tiene que conectar
   */
  guardar(urlBase: string, sinDelegadoLocal: boolean, sinDelegadoVisitante: boolean, sinLesionesLocal: boolean, sinLesionesVisitante: boolean, lesionados: mod.IActasLesionado[]): Observable<mod.IActasLesiones_DTO> {
    return new Observable<mod.IActasLesiones_DTO>(observer => {

      this.lesionados.info.sinDelegadoLocal = sinDelegadoLocal;
      this.lesionados.info.sinDelegadoVisitante = sinDelegadoVisitante;
      this.lesionados.info.sinLesionesLocal = sinLesionesLocal;
      this.lesionados.info.sinLesionesVisitante = sinLesionesVisitante;
      this.lesionados.lesionados = lesionados;

      this.http.post(this.UrlBase(urlBase) + 'guardarLesionados?guardarLesionados=true', this.lesionados)
        .subscribe({
          next: (resultado: mod.IActasLesiones_DTO) => {
            this.lesionados = resultado;
            this.l$.next(this.lesionados);

            observer.next(this.lesionados);
            observer.complete();
          },
          error: (error) => console.error(error)
        });
    });
  }

  /**
   * Obtiene la información relacionada con los lesionados de una designació, que se haya guardado en el sistema.
   * @param urlBase   Url de la API a la que se tiene que conectar.
   * @param idDesignacion Identificador de la designación.
   * @param idCalendario Identificador del partido
   */
  obtenerPorDesignacion(urlBase: string, idDesignacion: number, idCalendario: number): Observable<mod.IActasLesiones_DTO> {
    return new Observable<mod.IActasLesiones_DTO>(observer => {
      this.http.get(this.UrlBase(urlBase) + 'obtenerLesionados?idDesignacion=' + idDesignacion.toString() + '&obtenerLesionados=true')
        .subscribe({
          next: (resultado: mod.IActasLesiones_DTO) => {
            if (resultado != null) {
              this.lesionados = resultado;
              this.l$.next(this.lesionados);
            } else {
              // Inicialización de los datos de los lesionados
              this.lesionados = {
                info: {
                  id: 0,
                  idDesignacion: idDesignacion,
                  idCalendario: idCalendario,
                  sinDelegadoLocal: false,
                  sinDelegadoVisitante: false,
                  sinLesionesLocal: false,
                  sinLesionesVisitante: false,
                },
                lesionados: []
              }
              this.l$.next(this.lesionados);
            }
            observer.next(this.lesionados);
          },
          error: (error) => console.error(error)
        });
    });
  }

  /**
   * Elimina el registro asociado con la información de lesionados de una designación, si lo hubiera.
   * @param urlBase Url de la API a la que se tiene que conectar
   * @param idDesignacion Identificador de la designación relacionada
   * @returns Booleano que indica si se ha realizado la eliminación.
   */
  eliminar(urlBase: string, idDesignacion: number): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.http.delete(this.UrlBase(urlBase) + 'eliminarLesionados?idDesignacion=' + idDesignacion.toString())
        .subscribe({
          next: (resultado: boolean) => {
            if (resultado) {
              this.lesionados.info.id = 0;
              this.lesionados.lesionados = [];
            }

            observer.next(resultado);
            observer.complete();
          },
          error: (error) => console.error(error)
        });
    });
  }

  /**
   *
   * @param url URL Base de la API
   * @returns Cadena con la dirección url base completa (URL Base de configuración + nombre del controlador a utilizar)
   */
  private UrlBase(url: string): string {
    return this.DireccionBase(url) + this._NombreServicio;
  }

  // #endregion

  // #region Métodos de control interno del servicio

  /**
   * Realiza la eliminación de un lesionado de la lista de lesionados
   * @param urlBase   Url de la API a la que se tiene que conectar
   * @param lesionado Datos del lesionado a eliminar
   */
  eliminarLesionado(urlBase: string, lesionado: mod.IActasLesionado): Observable<mod.IActasLesiones_DTO> {
    this.lesionados.lesionados = this.lesionados.lesionados.filter(m => m.id != lesionado.id);

    return new Observable<mod.IActasLesiones_DTO>(observer => {
      this.http.post(this.UrlBase(urlBase) + 'guardarLesionados?guardarLesionados=true', this.lesionados)
        .subscribe({
          next: (resultado: mod.IActasLesiones_DTO) => {
            this.lesionados = resultado;
            this.l$.next(this.lesionados);

            observer.next(this.lesionados);
            observer.complete();
          },
          error: (error) => console.error(error)
        });
    });
  }

  /**
   * Elimina los lesionados que se hayan añadido en el equipo indicado.
   * @param idEquipo Identificador del equipo
   */
  eliminarLesionadosPorEquipo(idEquipo: number): void {
    if (this.lesionados != null && this.lesionados.lesionados != null && this.lesionados.lesionados.length > 0) {
      this.lesionados.lesionados = this.lesionados.lesionados.filter(m => m.idEquipo != idEquipo);
    }
  }

  /**
   * Indica si se ha guardado correctamente la información de los lesionados.
   *
   * Se comprobará si existe el registro y que este tiene un identificador mayor que cero.
   */
  guardadoCorrectoInfoLesionados(): boolean {
    return this.lesionados != null && this.lesionados.info != null && this.lesionados.info.id > 0;
  }

  /**
   * Inserta un nuevo lesionado.
   * @param urlBase Url base de la API
   * @param participante Datos del participante
   * @param licencia Datos de la licencia relacionada con el participante
   * @param lesion Texto con la información de la lesión
   * @param minuto Minuto de la lesión
   */
  incluirLesionado(urlBase: string, participante: Proxy.PrParticipacion, licencia: Proxy.PrPersonaAlineable, lesion: string, minuto: number): Observable<mod.IActasLesiones_DTO> {
    if (this.lesionados.lesionados == null) {
      this.lesionados.lesionados = [];
    }

    this.lesionados.lesionados.push({
      apellido1: licencia.apellido1,
      apellido2: licencia.apellido2,
      id: 0,
      idEquipo: participante.idEquipo,
      idInfoLesion: this.lesionados.info.id,
      idJugador: participante.idRegistro,
      lesion: lesion,
      minuto: minuto,
      nombre: licencia.nombre
    });

    return new Observable<mod.IActasLesiones_DTO>(observer => {
      this.http.post(this.UrlBase(urlBase) + 'guardarLesionados?guardarLesionados=true', this.lesionados)
        .subscribe({
          next: (resultado: mod.IActasLesiones_DTO) => {
            this.lesionados = resultado;
            this.l$.next(this.lesionados);

            observer.next(this.lesionados);
            observer.complete();
          },
          error: (error) => console.error(error)
        });
    });
  }

  /**
   * Indica si es correcta la información de los lesionados cargados.
   * @param idLocal   Identificador del equipo local
   * @param idVisitante Identificador del equipo visitante
   */
  informacionLesionadosValida(idLocal: number, idVisitante: number): boolean {
    let resultado: boolean = false;

    // Debe cumplirse que se ha guardado el registro de Info lesionados (su id debe ser mayor que cero)
    if (this.lesionados != null && this.lesionados.info != null && this.lesionados.info.id > 0) {
      let localValido: boolean = false;
      let visitanteValido: boolean = false;

      if (this.lesionados.info.sinDelegadoLocal || this.lesionados.info.sinLesionesLocal || (!this.lesionados.info.sinLesionesLocal && this.lesionados.lesionados.find(m => m.idEquipo == idLocal) != null)) {
        localValido = true;
      }
      if (this.lesionados.info.sinDelegadoVisitante || this.lesionados.info.sinLesionesVisitante || (!this.lesionados.info.sinLesionesVisitante && this.lesionados.lesionados.find(m => m.idEquipo == idVisitante) != null)) {
        visitanteValido = true;
      }

      resultado = localValido && visitanteValido;
    }

    return resultado;
  }

  /**
   * Indica si ya se ha incluido a la persona como lesionado.
   * @param idJugador   Identificador del jugador.
   */
  lesionadoExistente(idJugador: number): boolean {
    return this.lesionados != null && this.lesionados.lesionados != null && this.lesionados.lesionados.find(m => m.idJugador == idJugador) != null ? true : false;
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/services/api/lesionados.service.ts